import React from "react";
import FirstCart from "../../src/assets/cart-1.png";
import Plan2D from "../../src/assets/2D-plan.png";
import Interior from "../../src/assets/Interior.png";
import Cunsulting from "../../src/assets/Consult.png";
// import fullRating from "../../src/assets/4.5-Star.png";
// import MidRating from "../../src/assets/4-Star.png";
// import LowRating from "../../src/assets/3.5-Star.png";
import "../style/cart.css";

const Cart = () => {
  return (
    <div className="container">
      <div className="first-container">
        <div className="first">
          <div className="first-cart">
            <img src={Plan2D} alt="property" />
          </div>
          <div className="details">
            <h3 className="top-name">2D Plan (Vasthu)</h3>
            <p className="Second-Content">
              The plan is a 2D (two-dimensional) drawing that shows features
              such as property boundaries.
            </p>
            <div className="features">
              <div className="features1">
                <p>Home</p>
                <p>Commercial</p>
              </div>
              <div className="features2">
                <p>Floor plan</p>
                <p>Site Plan</p>
              </div>
            </div>
            <div>
              <p className="Second-Content">Designing period : 2 Days</p>
              <p className="Second-Content">
                Rating:{" "}
                {/* <img src={fullRating} alt="property" className="rating" /> */}
              </p>
            </div>
          </div>
        </div>
        <div className="first">
          <div className="first-cart">
            <img src={Interior} alt="property" />
          </div>
          <div className="details">
            <h3 className="top-name">Interior Design</h3>
            <p className="Second-Content">
              Interior design is the art of arranging and decorating the inside
              of a space to make it beautiful and comfortable.
            </p>
            <div className="features">
              <div className="features1">
                <p>Residential</p>
                <p>Commercial</p>
              </div>
              <div className="features2">
                <p>Modern</p>
                <p>Traditional</p>
              </div>
            </div>
            <div>
              <p className="Second-Content">
                Construct period : Based on requirement
              </p>
              <p className="Second-Content">
                Rating:{" "}
                {/* <img src={MidRating} alt="property" className="rating" /> */}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="Second-container">
        <div className="first">
          <div className="first-cart">
            <img src={Cunsulting} alt="property" />
          </div>
          <div className="details">
            <h3 className="top-name">Consulting and Supervising</h3>
            <p className="Second-Content">
              providing expert advice, solutions and supervising focuses on
              overseeing and managing project.
            </p>
            <div className="features">
              <div className="features1">
                <p>Construction</p>
                <p>Financial</p>
              </div>
              <div className="features2">
                <p>Legal</p>
                <p>Safety</p>
              </div>
            </div>
            <div>
              <p className="Second-Content">
                Construct period : Based on Requirements
              </p>
              <p className="Second-Content">
                Rating:{" "}
                {/* <img src={LowRating} alt="property" className="rating" /> */}
              </p>
            </div>
          </div>
        </div>

        <div className="first">
          <div className="first-cart">
            <img src={FirstCart} alt="property" />
          </div>
          <div className="details">
            <h3 className="top-name">Modern Indian Home</h3>
            <p className="Second-Content">
              Custom-designed, High-quality marble, high-end interiors, Private
              gardens, swimming pool
            </p>
            <div className="features">
              <div className="features1">
                <p>Kitchen</p>
                <p>Bedroom</p>
              </div>
              <div className="features2">
                <p>Restroom</p>
                <p>Car Parking</p>
              </div>
            </div>
            <div>
              <p className="Second-Content">
                Construct period : Based on Requirements
              </p>
              <p className="Second-Content">
                Rating:{" "}
                {/* <img src={fullRating} alt="property" className="rating" /> */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
